import { c as _c } from "react/compiler-runtime";
import { TextPassage } from '@petsmart-ui/sparky';
import { ResponsivePicture } from '../../ResponsivePicture';
import './set-up-autoship.scss';
type SetUpAutoshipProductInfoProps = Readonly<{
  name: string;
  imageUrl: string;
}>;
export const SetUpAutoshipProductInfo = t0 => {
  const $ = _c(9);
  const {
    name,
    imageUrl
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      width: 80,
      height: 80
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== imageUrl || $[2] !== name) {
    t2 = <div className="set-up-autoship__product-image"><ResponsivePicture src={imageUrl} alt={name} size={t1} /></div>;
    $[1] = imageUrl;
    $[2] = name;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== name) {
    t3 = <div className="set-up-autoship__product-name"><TextPassage>{name}</TextPassage></div>;
    $[4] = name;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2 || $[7] !== t3) {
    t4 = <div className="set-up-autoship__product">{t2}{t3}</div>;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
};